module.exports = __webpack_public_path__ + "img/light-theme.863f46cb.svg";